import React from "react";

const AccessDenied = () => {
  return <div>Access Denied</div>;
};

export default AccessDenied;